import { Route } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';

export const userRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./user-list-page/user-list-page.component').then(
        (c) => c.UserListPageComponent
      ),
  },
  {
    path: RoutePath.create,
    loadComponent: () =>
      import('./user-form/user-form.component').then(
        (c) => c.UserFormComponent
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./user-detail/user-detail.component').then(
        (c) => c.UserDetailComponent
      ),
  },
  {
    path: `:id/${RoutePath.edit}`,
    loadComponent: () =>
      import('./user-form/user-form.component').then(
        (c) => c.UserFormComponent
      ),
  },
];
